import { render, staticRenderFns } from "./ShippingCarrierSettings.vue?vue&type=template&id=58570d94"
import script from "./ShippingCarrierSettings.vue?vue&type=script&lang=js"
export * from "./ShippingCarrierSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports